import { render, staticRenderFns } from "./DailyChallenge.vue?vue&type=template&id=c8b41e34&scoped=true"
import script from "./DailyChallenge.vue?vue&type=script&lang=js"
export * from "./DailyChallenge.vue?vue&type=script&lang=js"
import style0 from "./DailyChallenge.vue?vue&type=style&index=0&id=c8b41e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b41e34",
  null
  
)

export default component.exports